import type { EtilizeProductModel } from '@peerless/data-access/etilize-api-client';

export function getProductImage(
  product: EtilizeProductModel | EtilizeProductModel['images'],
  size?: number
): string | undefined {
  const images = Array.isArray(product) ? product : product.images;
  if (!images || images.length === 0) {
    return undefined;
  }

  const mainImage = images.find(image => image.type === 'main') ?? images[0];

  if (size) {
    // find the smallest image size that is at least the requested size
    return mainImage.sizes.filter(sz => sz.size >= size).at(-1)?.src ?? mainImage.src;
  }

  return mainImage.src;
}
